/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GetOpenReg, SEND_COMMITTE_MEMBER_INVITES } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { pretty } from "@vlinder-web/utils-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface SendPurchaseInviteUserProps {
  presentation: any;
  section?: any;
  // action?:any;
  type?: any;
  email?: any;
  count?: any;
  maxInvites?: any;
  sectionOptType?: any;
  partition?: any;
}
export interface ISendPurchaseInviteMethods extends IPluginMethodMap {
  sendPurchaseInviteUser(args: SendPurchaseInviteUserProps): Promise<any>;
}

export class SendPurchaseInviteUserService implements IAgentPlugin {
  readonly methods: ISendPurchaseInviteMethods;

  constructor() {
    this.methods = {
      sendPurchaseInviteUser: this.sendPurchaseInviteUser.bind(this),
    };
  }

  async sendPurchaseInviteUser(args: SendPurchaseInviteUserProps) {
    console.log("sendPurchaseInviteUser--->", args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("send invite=====", pretty(args));
    try {
      if (client) {
        const id = await client.query({
          query: GetOpenReg,
          variables: {},
          fetchPolicy: "network-only",
        });
        const res = await client.mutate({
          mutation: SEND_COMMITTE_MEMBER_INVITES,
          variables: {
            data: [{
              ...args,
              maxInvites: parseInt(args?.maxInvites, 10) || 0,
              email: id?.data?.getOpenReg?.user?.email
            }],
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.sendPurchaseReferals,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  // private createInviteObjects(data: any) {
  //   const {
  //     presentation,
  //     type,
  //     sections,
  //     email,
  //     maxInvites,
  //     sectionOptType,
  //     partition,
  //   } = data;

  //   console.log("invite user service=====", pretty(data));
  //   const inviteObjects: any[] = [];

  //   const inviteObj = {
  //     email,
  //     presentation,
  //     partition,
  //     sections: sections ? sections : null,
  //     inviteType: "Open",
  //     maxInvites: parseInt(maxInvites, 10) || 0,
  //     sectionOptType,
  //     openRegEnabled: true,
  //   };
  //   inviteObjects.push(inviteObj);
  //   return inviteObjects;
  // }
}
